export default "__VITE_ASSET__460eaeb6__"